import React from "react";
import FindDealer from "../../components/find-dealer";
import {useDispatch, useSelector} from "react-redux";
import {UPDATE_LOB_VALUE} from "./../../redux/ActionTypes";
import axios from "axios";

import { configuration } from "../../helpers/config";
import ErrorBanner from "../../components/ErrorPage/ErrorBanner";
import {Constants} from "../../helpers/constants";
import { MenuFunction ,FooterFunction} from "../../utils/menu";
export async function getServerSideProps(context) {
  const { req } = context;
  const currentUrl = `${req.headers.host}`;
  const apiData = await axios.get(
    `${configuration.APP_URL_CONTENTS}/dealer-code?url=${currentUrl}`,
  );
  const lobData = apiData?.data?.result?.[0] || "" ;
  try {
    const Menudata = await MenuFunction(lobData?.dealerCode);
    const Footerdata = await FooterFunction(lobData?.dealerCode);
    return {
      props: {
        Menudata:Menudata,
        Footerdata:Footerdata,
      },
    };
  } catch (err) {
    console.warn(err, "Error Data"); 
    return {
      props: {
        error: true,
      },
    };
  }
}

const Finddealer4w = () => {
  const dispatch = useDispatch()
  dispatch({type: UPDATE_LOB_VALUE, payload: configuration.COMMON_MASTER_LOB});
  const isDealerWebsite = useSelector(({ app }) => app.isDealerWebsite);
  return (
    <div>
      {isDealerWebsite ? <ErrorBanner
          image="/errorBanner.png"
          imageMob="/errorMob.png"
          error="404"
          desc={Constants.error.DESCRIPTION}
          btn={Constants.error.BUTTON_TEXT}
      /> :<FindDealer lob={configuration.COMMON_MASTER_LOB}/>}
    </div>
  );
};

export default Finddealer4w;